import { usePageTitle } from "@/hooks/use-page-title";
import { authClient } from "@/lib/auth-client";

export function DashboardPage() {
  usePageTitle("Dashboard");
  const { data: session } = authClient.useSession();

  return (
    <div>
      <h1 className="text-3xl font-bold tracking-tight">
        Welcome, {session?.user?.name ?? "User"}
      </h1>
    </div>
  );
}
